export function once (key, fn) {
  const { process = {} } = global
  const processKey = key + '__ONCE__'
  if (!process[processKey]) {
    process[processKey] = true
    fn()
  }
}
